import React, { Component } from 'react';
import styled, { css, ThemeProvider } from 'styled-components';
import {
  Card,
  CardContent,
  CardSpacing,
  Column,
  Container,
  Row
} from './CommonUiComponents';
import StatusWrapper from './StatusWrapper';
import StatusLoader from './StatusLoader';
import { textGray } from '../utils/colors';
import apiRequest from '../utils/apiRequest';
import NoBook from './NoBook';
import LoginForm from './LoginForm';
import LoginForgot from './LoginForgot';
import LoginNewPassword from './LoginNewPassword';

const LoginContainer = Container.extend`
  margin: 0;
  margin-left: auto;
`;

const TopSection = styled.div`
  margin: 0 auto;
  position: relative;
  margin-top: 4rem;

  @media all and (max-width: 1024px) {
    margin-top: 3rem;
    text-align: center;
  }
`;

const LoginCard = styled(Card)`
  background-color: #ffffff;
`;

const BookTitle = styled.h1`
  font-size: 4rem;
  line-height: 2.8125rem;
  color: ${textGray};
  margin-top: 0.75rem;

  ${props =>
    props.inverted &&
    css`
      color: #ffffff;
    `};

  @media all and (max-width: 40rem) {
    font-size: 2rem;
  }
`;

const BookCategory = styled.span`
  font-size: 0.75rem;
  text-transform: uppercase;
  color: ${textGray};
  font-weight: 400;
  letter-spacing: 1px;

  ${props =>
    props.inverted &&
    css`
      color: #ffffff;
    `};
`;

export default class Login extends Component {
  state = {
    bookData: null,
    fetchingBookData: false,
    formType: Login.getDefaultFormState(this.props)
  };

  static getDefaultFormState(props) {
    const {
      history: {
        location: { search, pathname }
      }
    } = props;

    if (search.match(/\?key=/)) {
      return 'new_password';
    } else if (pathname.match(/\/glemt/)) {
      return 'forgot';
    }
    return 'login';
  }

  async componentDidMount() {
    await this.fetchBookData();
    await this.setBodyThemeColor();
  }

  componentDidUpdate() {
    this.setBodyThemeColor();
  }

  setBodyThemeColor() {
    const body = document.body;
    const { bookData } = this.state;

    if (bookData && bookData.theme) {
      body.style.backgroundColor = bookData.theme.primary;
    }
  }

  async fetchBookData() {
    const { setInvertedTheme, unsetInvertedTheme } = this.props;
    const { params } = this.props.match;

    this.setState({ fetchingBookData: true });

    const response = await apiRequest(
      'wordpress',
      `bookdata/v1/login?id=${params.bookId}`
    );

    if (response.theme && response.theme.text_color === 'dark') {
      setInvertedTheme();
    } else {
      unsetInvertedTheme();
    }

    this.setState({
      fetchingBookData: false,
      bookData: response
    });
  }

  render() {
    const {
      user: { loggingIn },
      invertedTheme
    } = this.props;
    const { bookData, fetchingBookData } = this.state;

    if (!bookData) return null;

    if (bookData.status === 404) {
      return (
        <NoBook inverted={invertedTheme}>
          Ojda, hva gjør du på denne URL'en?
        </NoBook>
      );
    }

    return (
      <ThemeProvider theme={bookData.theme}>
        <StatusLoader fullsize large busy={fetchingBookData}>
          <LoginContainer>
            <Row>
              <Column>
                <TopSection>
                  <BookCategory inverted={invertedTheme}>
                    {bookData.course_name}
                  </BookCategory>
                  <BookTitle inverted={invertedTheme}>
                    «{bookData.title}»
                  </BookTitle>
                </TopSection>
              </Column>
            </Row>
            <Row>
              <Column>
                <LoginCard>
                  <CardSpacing>
                    <CardContent>
                      <StatusWrapper busy={loggingIn}>
                        {this.renderCorrectForm()}
                      </StatusWrapper>
                    </CardContent>
                  </CardSpacing>
                </LoginCard>
              </Column>
            </Row>
          </LoginContainer>
        </StatusLoader>
      </ThemeProvider>
    );
  }

  renderCorrectForm() {
    const {
      user: { loginError, loggingIn, hasAccess },
      login,
      forgot,
      newPassword,
      invertedTheme,
      history
    } = this.props;
    const { formType } = this.state;

    switch (formType) {
      case 'forgot':
        return (
          <LoginForgot
            forgot={forgot}
            loginError={loginError}
            loggingIn={loggingIn}
            invertedTheme={invertedTheme}
          />
        );
      case 'new_password':
        const resetKey = history.location.search.match(/key=([^&]*)/);
        const email = history.location.search.match(/email=([^&]*)/);
        return (
          <LoginNewPassword
            newPassword={newPassword}
            resetKey={resetKey ? resetKey[1] : ''}
            email={email ? email[1] : ''}
            loginError={loginError}
            loggingIn={loggingIn}
            invertedTheme={invertedTheme}
          />
        );
      case 'login':
      default:
        return (
          <LoginForm
            hasAccess={hasAccess}
            login={login}
            loggingIn={loggingIn}
            invertedTheme={invertedTheme}
            loginError={loginError}
          />
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Login.js